import { fetcher } from "@website/fetcher/fetcher";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { useSnackbar } from "@website/ui/snackbar";
import { today, tomorrow } from "@website/utils/date-format";
import get from "lodash-es/get";
import { useRouter } from "next/router";
import { useState } from "react";
import { ENDPOINTS } from "../../../constants";
export const useBooking = properties => {
  const {
    propertyID,
    min_stay,
    handleTrackReserveButtonClicked
  } = properties;
  const {
    enqueue
  } = useSnackbar();
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const entryTime = new Date();
  const {
    date_to,
    date_from,
    roomId,
    extra_capacity
  } = router.query as Record<string, string>;
  const createBook = () => {
    const payload = {
      checkin: date_from || today(),
      checkout: date_to || tomorrow(),
      propertyID: propertyID,
      product: "VILLA",
      rooms: [{
        guestsCount: Number(get(router.query, "room_capacity")),
        roomID: Number(roomId),
        extraBeds: Number(extra_capacity)
      }]
    };
    setIsLoading(true);
    handleTrackReserveButtonClicked();
    return fetcher({
      url: `${ENDPOINTS.CREATE_BOOK}`,
      method: "POST",
      data: payload
    }).then(({
      data
    }) => {
      addEventToTracking(USER_TRACKING_EVENTS.TIME_MS_SPENT, {
        product: "villa",
        time_ms_spent: new Date()?.getTime() - entryTime?.getTime()
      });
      return router.push({
        pathname: `/shopping/[shopId]/detail`,
        query: {
          shopId: data?.id,
          publicKey: data?.publicKey
        }
      }, undefined, {
        shallow: true,
        scroll: true
      });
    }).catch(error => {
      const errorMessage = error?.response?.message;
      enqueue(errorMessage, "error", "one-line");
    }).finally(() => setIsLoading(false));
  };
  const showMinStayAlarm = (() => {
    if (!date_from || !date_to || !min_stay) return true;
    const date1 = new Date(date_from as string);
    const date2 = new Date(date_to as string);
    const diffMs = Math.abs(date2.getTime() - date1.getTime());
    return diffMs / (1000 * 60 * 60 * 24) < min_stay;
  })();
  return {
    isLoading,
    createBook,
    showMinStayAlarm
  };
};